import React from 'react';
import getConfig from 'next/config';
import SkipLink from '@domain-group/fe-co-skip-link';

import { GetServerSideProps } from 'next';
import {
  ErrorBoundary,
  LandingPage,
  LandingPage2026,
  LandingPageHead,
  LandingPageHeader,
  LandingPageFooter,
} from '../../components';
import { skipLinkName } from '../../helper/accessibility-utils';
import { AppPageProps } from '../_app';
import { getUserDetails } from '../../utils';
import { UserDetailsRedacted } from '../../@types';
import { isLandingPageUpliftEnabled } from '../../services/feature-flag-services';

const { publicRuntimeConfig } = getConfig();

interface Props extends AppPageProps {
  user: UserDetailsRedacted;
  isEmbeddedApp: boolean;
  mixpanelHasInitialized?: boolean;
  isNewLandingPage: boolean;
}

const FindAnAgentLandingPage = ({
  user,
  isEmbeddedApp = false,
  mixpanelHasInitialized = false,
  isNewLandingPage = false,
}: Props): JSX.Element => {
  const breadcrumbs = [
    {
      title: 'Real Estate Agents',
      url: `${publicRuntimeConfig.BASE_URL}/real-estate-agents/`,
    },
  ];

  return (
    <ErrorBoundary>
      <>
        <LandingPageHead breadcrumbsData={breadcrumbs} user={user} />
        <SkipLink anchorName={skipLinkName} />
        {isEmbeddedApp ? null : (
          <LandingPageHeader breadcrumbsData={breadcrumbs} />
        )}
        {isNewLandingPage ? (
          <LandingPage2026 skipLinkContentId={skipLinkName} />
        ) : (
          <LandingPage
            skipLinkContentId={skipLinkName}
            mixpanelHasInitialized={mixpanelHasInitialized}
          />
        )}
        {isEmbeddedApp ? null : <LandingPageFooter />}
      </>
    </ErrorBoundary>
  );
};

export default FindAnAgentLandingPage;

export const getServerSideProps: GetServerSideProps<Props> = async ({
  req,
  res,
}) => {
  const user = getUserDetails(req.user);
  const forceNewLandingPage = req.query.forcelandingpage2026 === '1';
  const isNewLandingPage =
    forceNewLandingPage || (await isLandingPageUpliftEnabled());

  const props = {
    // _app.js props
    serverInfo: res.locals.serverInfo,
    mixpanelToken: publicRuntimeConfig.MIXPANEL_TOKEN,

    // User data
    user,

    // page props
    isEmbeddedApp: req.isEmbeddedApp,
    isNewLandingPage,
  };

  return JSON.parse(
    JSON.stringify({
      props,
    }),
  );
};
